import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { getProfileId } from '@/utils/profile';
import Profile from '@/views/profile/Profile.vue';
import { profileExamResultsRoute } from './profieExamResults';
import { profileDetailsRoute } from './profileDetails.route';
import { profileEditRoute } from './profileEdit.route';
import { profileMedicalExaminationRoute } from './profileMedicalExamination.route';
import { profileOffersRoute } from './profileOffers.route';

export const myProfileRoute: RouteConfig = {
  path: 'profile',
  component: Profile,
  children: [
    profileDetailsRoute('myProfile'),
    profileEditRoute('myProfileEdit'),
    profileOffersRoute('myProfileOffers'),
    profileMedicalExaminationRoute('myProfileMedicalExamination'),
    profileExamResultsRoute('myProfileExamResult')
  ],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.profiles.view',
      name: 'myProfile'
    }
  },
  props: {
    tabs: [
      { title: 'tabs.profile.details', route: { name: 'myProfile' }, permissions: ['USER.GET'] },
      { title: 'tabs.profile.edit', route: { name: 'myProfileEdit' }, permissions: ['USER.UPDATE'] },
      { title: 'tabs.profile.offers', route: { name: 'myProfileOffers' }, permissions: ['OFFER.LIST'] },
      {
        title: 'tabs.profile.medicalExamination',
        route: { name: 'myProfileMedicalExamination' },
        permissions: ['USER.MEDICAL_EXAMINATION']
      },
      {
        title: 'tabs.profile.examResult',
        route: { name: 'myProfileExamResult' },
        permissions: ['USER.EXAM_RESULT']
      }
    ]
  },

  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('profile/setId', getProfileId());
    store
      .dispatch('profile/get')
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.profile.getError' }));
  }
};
